import { TImage } from '@components/typescript';
const getImageSrc = (image: TImage, currentDevice: string): string => {
  const currentDeviceImage = image[currentDevice];
  let imageSRC = '';
  if (currentDeviceImage) {
    imageSRC = typeof currentDeviceImage === 'string' ? currentDeviceImage : currentDeviceImage.path || '';
  }
  if (!imageSRC) {
    const desktopImage = image.desktop;
    if (desktopImage) {
      imageSRC = typeof desktopImage === 'string' ? desktopImage : desktopImage.path || '';
    }
  }
  return imageSRC;
};
export default getImageSrc;